module.exports = __webpack_public_path__ + "static/media/brown-regular.e310f69a.ttf";